module.exports = __webpack_public_path__ + "img/credit.ba4079bf.svg";